function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgJcb = function SvgJcb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7 12h5.72v8H7zM13.45 12h5.72v8h-5.72zM19.86 12h5.72v8h-5.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.019 10.987V22.83v-4.844A2.104 2.104 0 017 17.98L7 22.83h3.511c.959 0 2.206-.89 2.206-2.242V9.008H9.25c-1.09 0-2.092.906-2.231 1.98v6.04c.248.14 1.243.454 1.65.483.912.064 1.477-.236 1.565-.99l-.005-2.804h2.018v2.74c-.106 1.568-1.492 1.888-3.602 1.782a9.822 9.822 0 01-1.626-.254v-6.998z",
    fill: "#1B6CA8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.696 9c-1.175 0-2.248 1.052-2.248 2.232v3.056c.704-.546 1.84-.814 3.286-.704.823.063 1.431.177 1.763.274v.97c-.366-.18-1.087-.45-1.689-.494-1.364-.097-2.08.537-2.08 1.563 0 .923.553 1.713 2.074 1.608.501-.035 1.336-.325 1.69-.493l.005.941a8.881 8.881 0 01-2.151.309c-1.348.01-2.298-.274-2.9-.735v5.293h3.511c.959 0 2.206-.889 2.206-2.24V9h-3.467z",
    fill: "#D92243"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.36 16.191c-.385.004-1.223-.004-1.375 0l-.003 1.22 1.376.006a.622.622 0 00.603-.624c0-.35-.29-.605-.601-.602zM22.794 14.966c0-.35-.265-.587-.547-.58-.396.008-1.11-.01-1.267.003l-.005 1.112 1.3.01a.553.553 0 00.52-.545z",
    fill: "#5FB345"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.109 9c-1.175 0-2.248 1.052-2.248 2.232v2.457h3.337c.665 0 1.447.283 1.447 1.084 0 .43-.23.918-1.062 1.076v.018c.485 0 1.327.282 1.327 1.133 0 .878-.91 1.122-1.396 1.122l-3.654.004-.002 4.694h3.512c.958 0 2.206-.889 2.206-2.24V9h-3.467z",
    fill: "#5FB345"
  }));
};
SvgJcb.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgJcb.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgJcb;